export default {"src":"/_next/static/media/icon-boom.a04f103e.svg","height":75,"width":75};